<div class="dro-reading-history">
  <div class="history-header" (click)="collapsed = !collapsed">
    <i class="fas" [ngClass]="collapsed ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
    <span class="title">Reading History</span>
    <span class="count-chip">{{ readings.length }} {{ readings.length === 1 ? 'reading' : 'readings' }}</span>
    <span class="hint">Newest first</span>
  </div>

  <div class="history-body" [hidden]="collapsed">
    @if (loading) {
      <lib-loader></lib-loader>
    }
    <div class="grid-area">
      @if (config(); as gridConfig) {
        @for (key of [columnsKey()]; track key) {
          <inavista-grid #grid [config]="gridConfig" (hyperlinkClick)="onLink($event)" (exportRequested)="onExport($event)" />
        }
      }
    </div>
    <div class="footnote">Every field on the form has its own column, matching the capture card. Open a reading id for the full record.</div>
  </div>

  <ng-template #recordedByCell let-row>
    <span class="recorded-by">{{ row.recordedBy }}@if (row.roles) { <span class="role-chip">{{ row.roles }}</span>}</span>
  </ng-template>
  <ng-template #sourceCell let-row>
    @if (row.serviceOrderId) {
      @if (serviceOrderClick.observed) {
        <a class="link" href="javascript:" (click)="$event.stopPropagation(); onServiceOrderClick(row.serviceOrderId)">{{ row.serviceOrderId }}</a>
      } @else {
        <span>{{ row.serviceOrderId }}</span>
      }
    } @else {
      <span class="standalone-chip"><i class="fas fa-desktop me-1"></i>Standalone</span>
    }
  </ng-template>
</div>
